/** Lightweight success toasts driven by API envelope `message`. */

const listeners = new Set();

/**
 * Subscribe to toast events (used by {@link ToastHost}).
 * @param {(payload: { message: string, variant: string }) => void} listener
 * @returns {() => void} Unsubscribe function.
 */
export function subscribeToasts(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * @param {string} message
 */
export function showSuccessToast(message) {
  showToast(message, 'success');
}

/**
 * @param {string} message
 * @param {'success' | 'warning' | 'danger'} [variant]
 */
export function showToast(message, variant = 'success') {
  const text = typeof message === 'string' ? message.trim() : '';
  if (!text) return;
  const v = variant === 'warning' || variant === 'danger' ? variant : 'success';
  listeners.forEach((listener) => {
    listener({ message: text, variant: v });
  });
}
